module.exports = "pegasus_template/assets/tech/small/4.jpg";